import clsx from 'clsx';
import useTranslation from 'next-translate/useTranslation';

// Lib
import type { DatepickerComparisonPeriodsAvailableType } from '@/lib/periods';
import { PREVIOUS_PERIOD, SAME_PERIOD_LAST_YEAR } from '@/lib/periods';

// Components
import ActionTag from '@/components/base/Tag/ActionTag';

export type DatepickerCompareToProps = {
    onChange: (arg: DatepickerComparisonPeriodsAvailableType) => void;
    compareTo: DatepickerComparisonPeriodsAvailableType;
};

const dataCompareTo = [
    { label: 'datepicker.previous_period', value: PREVIOUS_PERIOD },
    { label: 'commons:datepicker.same_period_last_year', value: SAME_PERIOD_LAST_YEAR }
] as const;

export const DatepickerCompareTo = ({ onChange, compareTo }: DatepickerCompareToProps) => {
    const { t } = useTranslation('commons');

    return (
        <div className="mt-3">
            <p className="mb-2 text-8 uppercase leading-[normal] tracking-0.5 text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('commons:datepicker.compare_to')}
            </p>
            <div className="flex flex-wrap items-center gap-1">
                {dataCompareTo.map((item) => {
                    const isSelected = compareTo === item.value;
                    return (
                        <button
                            key={item.value}
                            type="button"
                            data-testid={
                                isSelected
                                    ? `datepicker-compare-to-${item.value}-selected`
                                    : `datepicker-compare-to-${item.value}`
                            }
                            className="rounded-full focus:ring-0"
                            onClick={() => onChange(item.value)}>
                            <ActionTag variant={isSelected ? 'option_blue' : 'option_transparent'}>
                                <span
                                    className={clsx('text-xxs leading-[normal]', {
                                        'text-icoBlack dark:text-white': !isSelected
                                    })}>
                                    {t(item.label)}
                                </span>
                            </ActionTag>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DatepickerCompareTo;
